export enum MenuTabPosition {
    Left,
    Right,
    Navi
}